module.exports = __webpack_public_path__ + "img/frame-mb.ad34df61.webp";